<script setup lang="ts">
// TODO провести рефакторинг
import './style.scss';

import { UiIcon, UiBadge } from '@shared/ui';
import type { UiBtnProps } from '@shared/ui';
import { NuxtLink } from '#components';

const className = 'ui-btn';

const {
  label,
  labelPre,
  alt,
  tag = 'button',
  icon,
  rightIcon,
  badge,
  badgeColor = 'neutral',
  href,
  target = '_self',
  rel,
  color = 'default',
  size = 'md',
  type,
  htmlType = 'button',
  disabled = false,
  exact = true,
  full = false,
  external = undefined,
  itemscope,
  itemtype,
  schemaUrl,
  schemaName,
} = defineProps<UiBtnProps>();

const getTagName = computed<string | typeof NuxtLink>(() => tag === 'a' ? NuxtLink : tag);

const getRel = computed<string | undefined>(() => rel);
</script>

<template>
  <component
    :is="getTagName"
    :href="tag === 'a' ? href : undefined"
    :target="tag === 'a' ? target : undefined"
    :rel="getRel"
    :type="tag === 'button' && htmlType ? htmlType : undefined"
    :disabled="disabled ?? undefined"
    :external="external"
    :itemscope="itemscope ? true : undefined"
    :itemtype="itemtype"
    :class="[
      className,
      {
        [`${className}_exact`]: exact,
        [`${className}_active`]: !exact,
        [`${className}_${color}`]: color,
        [`${className}_${size}`]: size,
        [`${className}_text`]: type === 'text',
        [`${className}_icon`]: type === 'icon',
        [`${className}_icon-only`]: (icon || rightIcon) && !label,
        'ui-w_full': full,
      },
    ]"
  >
    <meta
      v-if="itemscope && schemaUrl"
      itemprop="url"
      :content="schemaUrl || href"
    >
    <span
      v-if="itemscope && schemaName"
      itemprop="name"
      class="hidden"
    >
      {{ schemaName }}
    </span>
    <span
      v-if="labelPre && type !== 'icon'"
      :class="`${className}__label`"
    >{{
      labelPre
    }}</span>
    <UiIcon
      v-if="icon"
      :name="icon"
      :class="`${className}__icon`"
    />
    <!-- eslint-disable vue/no-v-html -->
    <span
      v-if="label && type !== 'icon'"
      :class="`${className}__label`"
      v-html="label?.trim()"
    />
    <span
      v-else-if="alt"
      class="sr-only"
    >{{ alt }}</span>
    <UiIcon
      v-if="rightIcon"
      :name="rightIcon"
      :class="`${className}__icon`"
    />
    <UiBadge
      v-if="badge"
      :label="badge"
      :color="badgeColor"
    />
  </component>
</template>
